<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter301thedevilprinceishere">CHAPTER 301 - THE DEVIL PRINCE IS HERE</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter302fightagain">CHAPTER 302 - FIGHT AGAIN</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter303conspiracyreconciliation">CHAPTER 303 - CONSPIRACY RECONCILIATION</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter304rejuvenatinglilaccontinent">CHAPTER 304 - REJUVENATING LILAC CONTINENT</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter305findanewidentity">CHAPTER 305 - FIND A NEW IDENTITY</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter306secretsofthesaintdevilsect">CHAPTER 306 - SECRETS OF THE SAINT DEVIL SECT</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter307descendantofthesaintdevilsect">CHAPTER 307 - DESCENDANT OF THE SAINT DEVIL SECT</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter308arrivingatshengdu">CHAPTER 308 - ARRIVING AT SHENG DU</a>
</li>
<li class="table-of-content">
<span href="#/8_chapter309votingandforbiddingforces" title="Link target outside of Sample">CHAPTER 309 - VOTING AND FORBIDDING FORCES</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter310imperialguardacademyofficer" title="Link target outside of Sample">CHAPTER 310 - IMPERIAL GUARD ACADEMY OFFICER</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter311gujianyunappeared" title="Link target outside of Sample">CHAPTER 311 - GU JIANYUN APPEARED</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter312toxicironspider" title="Link target outside of Sample">CHAPTER 312 - TOXIC IRON SPIDER</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter313goldenspider" title="Link target outside of Sample">CHAPTER 313 - GOLDEN SPIDER</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter314ibeattheshitoutofyou" title="Link target outside of Sample">CHAPTER 314 - I BEAT THE SHIT OUT OF YOU</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter315theinfernalkingneededpoison" title="Link target outside of Sample">CHAPTER 315 - THE INFERNAL KING NEEDED POISON?</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter316rumors" title="Link target outside of Sample">CHAPTER 316 - RUMORS</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter317theinfernalkingslove" title="Link target outside of Sample">CHAPTER 317 - THE INFERNAL KING'S LOVE</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter318feudalfiefdomintheblackhell" title="Link target outside of Sample">CHAPTER 318 - FEUDAL FIEFDOM IN THE BLACK HELL</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter319openhouse" title="Link target outside of Sample">CHAPTER 319 - OPEN HOUSE</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter320firstarrivalfiefdom" title="Link target outside of Sample">CHAPTER 320 - FIRST ARRIVAL FIEFDOM</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter321buyaminer" title="Link target outside of Sample">CHAPTER 321 - BUY A MINER</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter322miningmining" title="Link target outside of Sample">CHAPTER 322 - MINING! MINING!</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter323orediscovered" title="Link target outside of Sample">CHAPTER 323 - ORE DISCOVERED</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter324stealyourhousewhenyouseeaninjustice" title="Link target outside of Sample">CHAPTER 324 - STEAL YOUR HOUSE WHEN YOU SEE AN INJUSTICE</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter325iliketotalkaboutthetermswithaponytail" title="Link target outside of Sample">CHAPTER 325 - I LIKE TO TALK ABOUT THE TERMS WITH A PONYTAIL</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter326lionsmouth" title="Link target outside of Sample">CHAPTER 326 - LION'S MOUTH</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter327theinfernalkingexplainsforyou" title="Link target outside of Sample">CHAPTER 327 - THE INFERNAL KING EXPLAINS FOR YOU</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter328whatisabovechaos" title="Link target outside of Sample">CHAPTER 328 - WHAT IS ABOVE CHAOS</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter329troubleshooting" title="Link target outside of Sample">CHAPTER 329 - TROUBLESHOOTING</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter330jinhuanxileakedthenews" title="Link target outside of Sample">CHAPTER 330 - JIN HUANXI LEAKED THE NEWS</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter331meetanoldfriendintheshengdu" title="Link target outside of Sample">CHAPTER 331 - MEET AN OLD FRIEND IN THE SHENG DU.</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter332imgonnadigaholeforyou" title="Link target outside of Sample">CHAPTER 332 - I'M GONNA DIG A HOLE FOR YOU</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter333steppoint" title="Link target outside of Sample">CHAPTER 333 - STEP POINT</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter334tostealthenethergodiron" title="Link target outside of Sample">CHAPTER 334 - TO STEAL THE NETHER GOD IRON</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter335thesuddenappearanceoftheinfernalking" title="Link target outside of Sample">CHAPTER 335 - THE SUDDEN APPEARANCE OF THE INFERNAL KING</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter336theinfernalkingssuspicion" title="Link target outside of Sample">CHAPTER 336 - THE INFERNAL KING'S SUSPICION</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter337wangdaochengreturnedtoshengdu" title="Link target outside of Sample">CHAPTER 337 - WANG DAOCHENG RETURNED TO SHENG DU.</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter338slaughtercity" title="Link target outside of Sample">CHAPTER 338 - SLAUGHTER CITY</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter339controllingtigerstoleavethemountain" title="Link target outside of Sample">CHAPTER 339 - CONTROLLING TIGERS TO LEAVE THE MOUNTAIN</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter340sneakattackonskydragoncontinent" title="Link target outside of Sample">CHAPTER 340 - SNEAK ATTACK ON SKY DRAGON CONTINENT</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter341greensnakewithdrawal" title="Link target outside of Sample">CHAPTER 341 - GREEN SNAKE WITHDRAWAL</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter342theheavenlyarmyisabouttoarrive" title="Link target outside of Sample">CHAPTER 342 - THE HEAVENLY ARMY IS ABOUT TO ARRIVE</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter343anteriorandposteriorpincers" title="Link target outside of Sample">CHAPTER 343 - ANTERIOR AND POSTERIOR PINCERS</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter344youwantmetonegotiatewiththem" title="Link target outside of Sample">CHAPTER 344 - YOU WANT ME TO NEGOTIATE WITH THEM?</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter345demonfightingarray" title="Link target outside of Sample">CHAPTER 345 - DEMON FIGHTING ARRAY</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter346pacify" title="Link target outside of Sample">CHAPTER 346 - PACIFY</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter347survey" title="Link target outside of Sample">CHAPTER 347 - SURVEY</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter348asadrunk" title="Link target outside of Sample">CHAPTER 348 - AS A DRUNK</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter349jinshiansrequest" title="Link target outside of Sample">CHAPTER 349 - JIN SHIAN'S REQUEST</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter350secondaryselection" title="Link target outside of Sample">CHAPTER 350 - SECONDARY SELECTION</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter351nearingtheyellowspringsplaneagain" title="Link target outside of Sample">CHAPTER 351 - NEARING THE YELLOW SPRINGS PLANE AGAIN</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter352hisidentityhadlongbeenrevealed" title="Link target outside of Sample">CHAPTER 352 - HIS IDENTITY HAD LONG BEEN REVEALED</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter353phantompoisonousfrog" title="Link target outside of Sample">CHAPTER 353 - PHANTOM POISONOUS FROG</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter354redsnakedemonempress" title="Link target outside of Sample">CHAPTER 354 - RED SNAKE DEMON EMPRESS</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter355tobesoldatprice" title="Link target outside of Sample">CHAPTER 355 - TO BE SOLD AT PRICE</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter356sneakattackfrombehind" title="Link target outside of Sample">CHAPTER 356 - SNEAK ATTACK FROM BEHIND</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter357lidaipeachstiff" title="Link target outside of Sample">CHAPTER 357 - LI DAI PEACH STIFF</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter358cutdowngrassandroot" title="Link target outside of Sample">CHAPTER 358 - CUT DOWN GRASS AND ROOT</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter359sfengshuangspast" title="Link target outside of Sample">CHAPTER 359 - 'S FENG SHUANG'S PAST</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter360planningrobbery" title="Link target outside of Sample">CHAPTER 360 - PLANNING ROBBERY</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter361demonicluodivinegeneral" title="Link target outside of Sample">CHAPTER 361 - DEMONIC LUO DIVINE GENERAL</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter362ninetailedwhitefox" title="Link target outside of Sample">CHAPTER 362 - NINE-TAILED WHITE FOX</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter363insertionreaction" title="Link target outside of Sample">CHAPTER 363 - INSERTION REACTION</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter364mastering" title="Link target outside of Sample">CHAPTER 364 - MASTERING</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter365causingahugeruckusinshengdu1" title="Link target outside of Sample">CHAPTER 365 - CAUSING A HUGE RUCKUS IN SHENG DU 1</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter366makingaruckusinshengdu2" title="Link target outside of Sample">CHAPTER 366 - MAKING A RUCKUS IN SHENG DU 2</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter367makingaruckusinshengdu3" title="Link target outside of Sample">CHAPTER 367 - MAKING A RUCKUS IN SHENG DU 3</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter368shengdus4" title="Link target outside of Sample">CHAPTER 368 - SHENG DU'S 4</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter369theinfernalkingstruebodyappeared" title="Link target outside of Sample">CHAPTER 369 - THE INFERNAL KING'S TRUE BODY APPEARED …</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter370oldmrandmrsli" title="Link target outside of Sample">CHAPTER 370 - OLD MR. AND MRS. LI</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter371exterminatingstrongenemy" title="Link target outside of Sample">CHAPTER 371 - EXTERMINATING STRONG ENEMY</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter372thirtysixgeneralsofthethunderclan" title="Link target outside of Sample">CHAPTER 372 - THIRTY-SIX GENERALS OF THE THUNDER CLAN</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter373beheadingtheinfernalkingsclone1" title="Link target outside of Sample">CHAPTER 373 - BEHEADING THE INFERNAL KING'S CLONE 1</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter374beheadingtheinfernalkingsclone2" title="Link target outside of Sample">CHAPTER 374 - BEHEADING THE INFERNAL KING'S CLONE 2</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter375beheadingtheinfernalkingsclone3" title="Link target outside of Sample">CHAPTER 375 - BEHEADING THE INFERNAL KING'S CLONE 3</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter376reunionafteralongabsence" title="Link target outside of Sample">CHAPTER 376 - REUNION AFTER A LONG ABSENCE</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter377dividedmagicalequipmentfordealingwithrichpeople" title="Link target outside of Sample">CHAPTER 377 - DIVIDED MAGICAL EQUIPMENT FOR DEALING WITH RICH PEOPLE</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter378darknessiseternity" title="Link target outside of Sample">CHAPTER 378 - DARKNESS IS ETERNITY</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter379anotherdealofthreehundredyears" title="Link target outside of Sample">CHAPTER 379 - ANOTHER DEAL OF THREE HUNDRED YEARS</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter380entanglement" title="Link target outside of Sample">CHAPTER 380 - ENTANGLEMENT</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter381therulesofthesixpathsofsamsara" title="Link target outside of Sample">CHAPTER 381 - THE RULES OF THE SIX PATHS OF SAMSARA</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter382deadspace" title="Link target outside of Sample">CHAPTER 382 - DEAD SPACE</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter383strongstarcontinent" title="Link target outside of Sample">CHAPTER 383 - STRONG STAR CONTINENT</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter384familiarfigure" title="Link target outside of Sample">CHAPTER 384 - FAMILIAR FIGURE</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter385whitejade" title="Link target outside of Sample">CHAPTER 385 - WHITE JADE</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter386returntoearth" title="Link target outside of Sample">CHAPTER 386 - RETURN TO EARTH</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter387firepartluoxuan" title="Link target outside of Sample">CHAPTER 387 - FIRE PART LUO XUAN</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter388boldbeauty" title="Link target outside of Sample">CHAPTER 388 - BOLD BEAUTY</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter389lishan" title="Link target outside of Sample">CHAPTER 389 - LISHAN</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter390secretrealm" title="Link target outside of Sample">CHAPTER 390 - SECRET REALM</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter391theidentityofanenemy" title="Link target outside of Sample">CHAPTER 391 - THE IDENTITY OF AN ENEMY?</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter392universalheartmeridian" title="Link target outside of Sample">CHAPTER 392 - UNIVERSAL HEART MERIDIAN</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter393ancestorsmethodoflecturing" title="Link target outside of Sample">CHAPTER 393 - ANCESTOR'S METHOD OF LECTURING</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter394pangukaitian" title="Link target outside of Sample">CHAPTER 394 - PAN GU KAITIAN</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter395threerealmssixdaos" title="Link target outside of Sample">CHAPTER 395 - THREE REALMS SIX DAOS</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter396bythelocaltyrants" title="Link target outside of Sample">CHAPTER 396 - BY THE LOCAL TYRANTS</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter397thegreatimmortalbattle" title="Link target outside of Sample">CHAPTER 397 - THE GREAT IMMORTAL BATTLE</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter398soulreaper" title="Link target outside of Sample">CHAPTER 398 - SOULREAPER</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter399foodiebeauty" title="Link target outside of Sample">CHAPTER 399 - FOODIE BEAUTY</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter400almostwrong" title="Link target outside of Sample">CHAPTER 400 - ALMOST WRONG</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?09b4bd41